import { HTTP_DESKRH } from '../http';

export default {

  getCollectors() {
    return HTTP_DESKRH.get('/collectors')
      .then(data => data)
      .catch(error => error);
  },

  getCollectorById(id) {
    return HTTP_DESKRH.get(`/collectors/${id}`)
      .then(data => data)
      .catch(error => error);
  },

  getSubscribedCollectors() {
    return HTTP_DESKRH.get('/collectorSubscriptions')
      .then(data => data)
      .catch(error => error);
  },

  subscribeToACollector(collector) {
    return HTTP_DESKRH.post('/collectorSubscription/add', collector)
      .then(data => data)
      .catch(error => error);
  },

  deleteSubscription(id) {
    return HTTP_DESKRH.delete(`/collectorSubscription/${id}`)
      .then(data => data);
  },

  updateSubscription(params) {
    return HTTP_DESKRH.put(`/collectorSubscription/${params.id}`, params)
      .then(data => data)
      .catch(error => error);
  },

  startCollectorRecuperation(id) {
    return HTTP_DESKRH.post(`/collectors/${id}/newRequest`)
      .then(data => data)
      .catch(error => error);
  },

  getCollectorsByCategory(collectorCategory) {
    return HTTP_DESKRH.post('/collectors/byCategory', { category: collectorCategory })
      .then(data => data)
      .catch(error => error);
  },

};



// WEBPACK FOOTER //
// ./src/api/collectors.js